'use strict';

/**
 * @ngdoc service
 * @name gfcmsApp.RavenService
 * @description
 * # raven.service
 * Service in the gfcmsApp.
 */
angular.module('gfcmsApp')
  .factory('ravenService', ravenService);

/**
 * @typedef {Object} RavenService
 * @function { (function({})) } loggedIn
 * @function { (function()) } loggedOut
 * @function { (function(): Raven|RavenStatic) } Raven
 **/

/**
 * @return {RavenService}
 */
function ravenService() {
  return {
    Raven: getRaven(),
    loggedIn: userLoggedIn,
    loggedOut: userLoggedOut
  };

  /**
   * @param user
   */
  function userLoggedIn(user) {
    getRaven().setUserContext(user);
  }

  function userLoggedOut() {
    getRaven().setUserContext();
  }

  /**
   * @return {Raven|RavenStatic}
   */
  function getRaven() {
    return window.Raven;
  }
}
